import { computed, ref, onMounted, onBeforeUnmount } from "vue"
import { useStore } from "vuex"

// Зеркалит стили: они переключаются на десктопную раскладку с
// `min-width: $breakpoint-tablet`, поэтому ровно 768px — уже не мобила.
const MOBILE_QUERY = "(max-width: 767.98px)"

// Единый источник состояния сайдбара.
// На мобиле сайдбар работает как drawer и всегда показывается в полном виде,
// поэтому сворачивание (sidebarCollapsed) на мобиле игнорируется.
export const useSidebar = () => {
  const store = useStore()

  const isMobile = ref(
    typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches
  )

  let mql = null
  const update = (event) => {
    isMobile.value = event.matches
  }

  onMounted(() => {
    mql = window.matchMedia(MOBILE_QUERY)
    isMobile.value = mql.matches
    mql.addEventListener("change", update)
  })

  onBeforeUnmount(() => {
    if (mql) mql.removeEventListener("change", update)
  })

  const collapsed = computed(
    () => store.state.sidebar.sidebarCollapsed && !isMobile.value
  )

  return { collapsed, isMobile }
}
